import { gql, TypedDocumentNode } from '@apollo/client'

import { DomainSliceDTO } from './types'

export const DOMAIN_FOR_PAGE_BASIC_ATTRIBUTES: TypedDocumentNode<DomainSliceDTO> = gql`
  fragment DomainForPageBasicAttributes on Domain {
    id
    name
    overriddenByYieldbird
    pubAdsServiceRefresh
  }
`
